export default __webpack_public_path__ + "static/media/rick-and-morty.c57b1dc2.jpg";